import {
  GET_REPORT_EMPLOYEE_SHIFTS_FAIL,
  GET_REPORT_EMPLOYEE_SHIFTS_SUCCESS,
  GET_REPORT_EMPLOYEE_TIPOUT_FAIL,
  GET_REPORT_EMPLOYEE_TIPOUT_SUCCESS,
  GET_REPORT_SUSHI_TIPOUT_FAIL,
  GET_REPORT_SUSHI_TIPOUT_SUCCESS,
  UPDATE_REPORT_BEGIN_DATE,
  UPDATE_REPORT_EMPLOYEE_ID,
  UPDATE_REPORT_END_DATE,
  UPDATE_REPORT_RESTAURANT_ID,
} from '../actions/actionTypes';
import { logout } from '../actions';

// const today = new Date();
// const twoWeeksAgo = new Date(Date.now() - 11005e5);
const today = new Date();

// 2. Calculate the end date (last Sunday)
const endDate = new Date(today); // Clone today's date
const dayOfWeek = today.getDay(); // 0 for Sunday, 1 for Monday, etc.

// Subtract days to get to the most recent Sunday.
// If today is Sunday (0), subtract 0 days.
// If today is Monday (1), subtract 1 day.
// If today is Saturday (6), subtract 6 days.
endDate.setDate(today.getDate() - dayOfWeek);

// Set time to the very end of that day for an inclusive range
endDate.setHours(23, 59, 59, 999);

// 3. Calculate the start date (Monday of two weeks ago)
const startDate = new Date(endDate); // Clone the end date

// Subtract 13 days to get to the Monday of the week prior.
// (e.g., Sunday the 14th -> minus 6 days is Monday the 8th -> minus 7 more days is Monday the 1st)
// Total days to subtract: 6 + 7 = 13
startDate.setDate(endDate.getDate() - 13);

// Set time to the very beginning of that day
startDate.setHours(0, 0, 0, 0);
const report = (
  state = {
    restaurantId: 1,
    beginDate: startDate,
    endDate: endDate,
    totalSushiTipOut: 0,
    employeeTipOut: {},
    employeeShifts: [],
  },
  action,
) => {
  switch (action.type) {
    case UPDATE_REPORT_RESTAURANT_ID:
      return {
        ...state,
        restaurantId: action.payload,
      };
    case UPDATE_REPORT_BEGIN_DATE:
      return {
        ...state,
        beginDate: action.payload,
      };
    case UPDATE_REPORT_END_DATE:
      return {
        ...state,
        endDate: action.payload,
      };
    case UPDATE_REPORT_EMPLOYEE_ID:
      return {
        ...state,
        employeeTipOut: {
          ...state.employeeTipOut,
          employeeId: action.payload,
        },
      };
    case GET_REPORT_SUSHI_TIPOUT_SUCCESS:
      return {
        ...state,
        totalSushiTipOut: Number(action.payload.SushiTipOutSummary.toFixed(2)),
      };
    case GET_REPORT_SUSHI_TIPOUT_FAIL:
      if (action.payload.status === 401) {
        logout();
      }
      return state;
    case GET_REPORT_EMPLOYEE_TIPOUT_SUCCESS:
      return {
        ...state,
        employeeTipOut: action.payload,
        employeeShifts: [],
      };
    case GET_REPORT_EMPLOYEE_TIPOUT_FAIL:
      if (action.payload.status === 401) {
        logout();
      }
      return state;
    case GET_REPORT_EMPLOYEE_SHIFTS_SUCCESS:
      action.payload.sort((a, b) => {
        var keyA = new Date(a.Date),
          keyB = new Date(b.Date);
        // Compare the 2 dates
        if (keyA < keyB) return -1;
        if (keyA > keyB) return 1;
        return 0;
      });
      return {
        ...state,
        employeeShifts: action.payload,
      };
    case GET_REPORT_EMPLOYEE_SHIFTS_FAIL:
      if (action.payload.status === 401) {
        logout();
      }
      return state;
    default:
      return state;
  }
};

export default report;
